import axios from 'axios';

export const API_ENDPOINT = process.env['REACT_APP_API_ENDPOINT'];
export const CONNECT_API_ENDPOINT = process.env['REACT_APP_CONNECT_API_ENDPOINT'];

export const leadApiAxios = axios.create({
  baseURL: API_ENDPOINT || '',
});

export const connectApiAxios = axios.create({
  baseURL: CONNECT_API_ENDPOINT || '',
});

export const localAxios = axios.create({
  baseURL: '',
});


connectApiAxios.interceptors.response.use(
  async ( res ) => {
    return res;
  },
  async ( err ) => {
    return await checkErrorsAndLogout(err);
  }
);

async function checkErrorsAndLogout( err: { config: any; code: string; } ) {
  const originalConfig = err.config;

  if (err.code === 'ERR_NETWORK' && !originalConfig._retry) {
    originalConfig._retry = true;

    document.getElementById('logout-button')?.click();
  }
  return Promise.reject(err);
}